/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { WAREHOUSE_SCHEMA_V4_OPTIONS } from 'cio/utils/warehouse';
import WarehouseSyncModel from 'cio/models/warehouse-sync';

interface WarehouseSyncCreateSelectDataArgs {
  model: WarehouseSyncModel;
  readOnly: boolean;
}

export default class WarehouseSyncCreateSelectData extends Component<WarehouseSyncCreateSelectDataArgs> {
  readonly options = WAREHOUSE_SCHEMA_V4_OPTIONS;

  @action
  updateOption(option: keyof WarehouseSyncModel, checked: boolean): void {
    this.args.model.set(option, checked);
  }
}
